<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          StyleNo：{{ formData.sampleStyleNo ? formData.sampleStyleNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ formData.productLine ? formData.productLine : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{
            formData.masterCategoryCodeName
              ? formData.masterCategoryCodeName
              : '--'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.sampleStatus === 'Y'
              ? 'primary'
              : formData.sampleStatus === 'S'
              ? 'success'
              : formData.sampleStatus === 'N'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.sampleStatusName }}
        </b-badge>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('from_label_sample_name_cn') || '样品中文名称'"
          >
            <el-input
              v-model="formData.sampleName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              clearable
              disabled
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('from_label_sample_name_en') || '样品英文名称'"
          >
            <el-input
              v-model="formData.sampleNameEn"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('table_label_Level_2_sample_classification') || '2级样品分类'
            "
            prop="categoryCode"
            ref="detailMaterialForm"
          >
            <category-cascader
              :masterCategoryCode.sync="formData.masterCategoryCode"
              :detailCategoryCode.sync="formData.categoryCode"
              :params="categoryParams"
              clearable
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_sampleSource') || '样品来源'"
                prop="sampleSource"
              >
                <dict-select
                  :placeholder="
                    $l('pe_select_sampleSource') || '请选择样品来源'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.sampleSource"
                  :body="sampleSourceTypeParams"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_sampleSalesSeason') || '销售季节'"
              >
                <dict-select
                  :placeholder="
                    $l('pe_select_sampleSalesSeason') || '请选择销售季节'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.sampleSalesSeason"
                  :body="sampleSalesSeasonTypeParams"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_business_name') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              clearable
              v-model="formData.salesPersonCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              :selectedLabel.sync="formData.salesPersonName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="'工厂业务人员'" prop="ftyPersonCode">
            <dict-select
              clearable
              v-model="formData.ftyPersonCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="'请选择工厂业务人员'"
              :selectedLabel.sync="formData.ftyPersonName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_label_designer') || '设计师'">
            <dict-select
              clearable
              v-model="formData.designerCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_designer') || '请选择设计师'
              "
              :selectedLabel.sync="formData.designerName"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('table_label_spec_length') || '长'"
                prop="specLength"
              >
                <el-input-number
                  v-model="formData.specLength"
                  placeholder="length"
                  clearable
                  size="small"
                  :controls="false"
                  :min="0"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('table_label_spec_width') || '宽'"
                prop="specWidth"
              >
                <el-input-number
                  v-model="formData.specWidth"
                  placeholder="width"
                  clearable
                  size="small"
                  :min="0"
                  :controls="false"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$l('table_label_spec_height') || '高'">
                <el-input-number
                  v-model="formData.specHeight"
                  placeholder="height"
                  size="small"
                  :min="0"
                  :controls="false"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_sampleSizeUnit') || '尺寸单位'"
              >
                <dict-select
                  :placeholder="
                    $l('pe_select_sampleSizeUnit') || '请选择产品规格'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.sampleSizeUnit"
                  :body="sampleSpecTypeParams"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_fringe_size') || '流苏尺寸'">
                <el-input
                  v-model="formData.fringeSize"
                  :placeholder="
                    $l('form_label_pe_fringe_size') || '请输入流苏尺寸'
                  "
                  type="text"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_sampleWeight') || '产品重量'"
              >
                <el-input-number
                  v-model="formData.sampleWeight"
                  placeholder="weight"
                  clearable
                  size="small"
                  style="width:100%"
                  :step="0.01"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_sampleWeightUnit') || '产品重量单位'"
              >
                <dict-select
                  :placeholder="
                    $l('pe_select_sampleWeightUnit') || '请选择产品重量单位'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.sampleWeightUnit"
                  :body="sampleWeightUnitTypeParams"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('table_label_factory') || '成品工厂'">
            <dict-select
              :placeholder="$l('pe_select_factory') || '请选择成品工厂'"
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              :body="scmParams"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_factory_product_number') || '工厂产品编号'"
          >
            <el-input
              v-model="formData.scmProductNo"
              :placeholder="
                $l('pe_select_factory_product_number') || '请输入工厂产品编号'
              "
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('table_label_moq') || '起订量'">
                <el-input-number
                  style="width:100%"
                  clearable
                  v-model="formData.moq"
                  :step="1"
                  :precision="0"
                  :min="0"
                  controls-position="right"
                  :placeholder="$l('pe_input_moq') || '请输入起订量'"
                  size="small"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('table_label_moqUnit') || '起订量单位'">
                <dict-select
                  :placeholder="$l('pe_select_moqUnit') || '请选择起订量单位'"
                  size="small"
                  clearable
                  filterable
                  v-model="formData.moqUnit"
                  :body="moqUnitTypeParams"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.label_customer') || '客户'">
            <dict-select
              clearable
              v-model="formData.custCode"
              filterable
              url="/master/common/dict/customerSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_customer') || '请选择客户'
              "
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_customerProductNo') || '客人产品编号'"
          >
            <el-input
              v-model="formData.customerProductNo"
              :placeholder="
                $l('pe_select_customerProductNo') || '请输入客人产品编号'
              "
              maxlength="50"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_label_poNo') || 'poNo'">
            <el-input
              v-model="formData.poNo"
              maxlength="50"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_dateOfSignature') || '签样日期'"
          >
            <el-date-picker
              v-model="formData.dateOfSignature"
              type="date"
              size="small"
              value-format="yyyy/MM/dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_custSampleName') || '客户样品名称'"
          >
            <el-input
              v-model="formData.custSampleName"
              maxlength="100"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_costMainType') || '主成本类型'"
                prop="costMainType"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.costMainType"
                  :body="costMainTypeParams"
                  :placeholder="
                    $l('pe_select_costMainType') || '请选择主成本类型'
                  "
                  url="/sys/common/dict/system"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('table_label_costPrice') || '成本价格'">
                <el-input-number
                  style="width:100%"
                  clearable
                  v-model="formData.costPrice"
                  :step="0.01"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  :placeholder="$l('pe_select_costPrice') || '请输入成本价格'"
                  size="small"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_costCurrency') || '成本价格币种'"
                prop="costCurrency"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.costCurrency"
                  :body="costCurrencyTypeParams"
                  :placeholder="
                    $l('pe_select_costCurrency') || '请选择成本价格币种'
                  "
                  url="/sys/common/dict/system"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_quotation_method') || '报价方式'"
                prop="quotedMethod"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.quotedMethod"
                  :body="quotedMethodTypeParams"
                  :placeholder="
                    $l('pe_select_quotation_method') || '请选择报价方式'
                  "
                  url="/sys/common/dict/system"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_quotedPrice') || '建议报价'"
              >
                <el-input-number
                  style="width:100%"
                  clearable
                  v-model="formData.quotedPrice"
                  :step="0.01"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  :placeholder="$l('pe_input_quotedPrice') || '请输入建议报价'"
                  size="small"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('table_label_quotedCurrency') || '建议报价币种'"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.quotedCurrency"
                  :body="quotedCurrencyTypeParams"
                  :placeholder="
                    $l('pe_select_quotedCurrency') || '请选择建议报价币种'
                  "
                  url="/sys/common/dict/system"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="!proofingCode" :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('table_label_salesType') || '售价类型'">
            <dict-select
              v-model="formData.salesType"
              :placeholder="$l('pe_select_salesType') || '请选择售价类型'"
              url="/sys/common/dict/system"
              :body="salesTypeParams"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('table_label_salesPrice') || '零售价'">
            <el-input-number
              v-model="formData.salesPrice"
              :placeholder="$l('pe_input_salesPrice') || '请输入零售价'"
              clearable
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_salesCurrency') || '零售价货币'"
          >
            <dict-select
              v-model="formData.salesCurrency"
              :placeholder="$l('pe_select_salesCurrency') || '请选择零售价货币'"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('table_label_packageSize') || '包装尺寸'">
            <el-input
              v-model="formData.packageSize"
              :placeholder="$l('pe_input_packageSize') || '请输入包装尺寸'"
              clearable
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_packageMethod') || '包装方式'">
            <dict-select
              v-model="formData.packageMethod"
              :placeholder="$l('pe_select_packageMethod') || '请选择包装方式'"
              url="/master/common/dict/biz"
              :body="packageMethodParams"
              clearable
              filterable
              multiple
              @loaded="(items) => (packageMethodItems = items)"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_proofingCycleDesc') || '打样周期说明'"
          >
            <el-input
              size="small"
              type="textarea"
              rows="4"
              v-model="formData.proofingCycleDesc"
              clearable
              show-word-limit
              maxlength="200"
              :placeholder="
                $l('pe_input_proofingCycleDesc') || '请输入打样周期说明'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_productionCycleDesc') || '生产周期说明'"
          >
            <el-input
              v-model="formData.productionCycleDesc"
              type="textarea"
              rows="4"
              :placeholder="
                $l('pe_input_productionCycleDesc') || '请输入生产周期说明'
              "
              clearable
              show-word-limit
              maxlength="200"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_shipment_cycle') || '出货周期说明'"
          >
            <el-input
              v-model="formData.shipmentCycleDesc"
              :placeholder="
                $l('pe_input_shipment_cycle') || '请输入出货周期说明'
              "
              type="textarea"
              rows="4"
              clearable
              show-word-limit
              maxlength="200"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('table_label_tagMemo') || '吊牌标签备注'">
            <el-input
              v-model="formData.tagMemo"
              :placeholder="$l('pe_input_tagMemo') || '请输入吊牌标签备注'"
              type="textarea"
              rows="4"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_remarks') || '备注说明'">
            <el-input
              v-model="formData.sampleMemo"
              type="textarea"
              rows="4"
              :placeholder="$l('pe_input_remarks') || '请输入备注说明'"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-3">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">{{
          $l('table_label_attribute') || '属性信息'
        }}</span>
      </div>
    </div>
    <el-row>
      <DynamicForm
        v-model="dynamicFormData"
        :items.sync="formData.metadata"
        :disabled="disabled"
        :gutter="10"
        ref="dynamicForm"
      />
    </el-row>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import DynamicForm from '@/components/dynamic-form'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: { DynamicForm },
  props: {
    disabled: { type: Boolean, default: false },
    sampleCode: { type: String, default: '' },
    proofingCode: { type: String, default: '' },
  },
  data() {
    return {
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      costMainTypeParams: { dictType: 'costMainType' },
      costCurrencyTypeParams: { dictType: 'costCurrency' },
      quotedMethodTypeParams: { dictType: 'quotedMethod' },
      quotedCurrencyTypeParams: { dictType: 'quotedCurrency' },
      salesTypeParams: { dictType: 'sampleSalesType' },
      packageMethodParams: { dictType: 'packageMethod' },
      sampleSourceTypeParams: { dictType: 'sampleSource' },
      sampleSalesSeasonTypeParams: { dictType: 'salesSeason' },
      sampleSpecTypeParams: { dictType: 'sampleSizeUnit' },
      sampleWeightUnitTypeParams: { dictType: 'sampleWeightUnit' },
      moqUnitTypeParams: { dictType: 'moqUnit' },
      scmParams: {},

      formData: {
        quotedMethod: 'FOB',
        categoryCodeName: '',
        costCurrency: 'CNY',
        productLine: 'ABSHome',
        metadata: [],
        salesType: 'Offline',
      },
      dynamicFormData: {},
      rules: {
        sampleSource: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_sampleSource') || '请选择来源',
            trigger: ' change',
          },
        ],
        costMainType: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_costMainType') || '请选择成本类型',
            trigger: ' change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_quotedMethod') || '请选择报价方式',
            trigger: ' change',
          },
        ],
        productLine: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_productLine') || '请选择产品线',
            trigger: 'change',
          },
        ],

        categoryCode: [
          {
            required: true,
            message:
              this.$l('pe_select_sample_classification') || '请选择样品分类',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_business_person') ||
              '请选择业务人员',
            trigger: 'change',
          },
        ],
        costCurrency: [
          {
            required: true,
            message: this.$l('pe_select_costCurrency') || '请选择成本价格币种',
            trigger: 'blur',
          },
        ],
        specLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('长必须大于0'))
              } else {
                callback()
              }
            },
          },
        ],
        specWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('宽必须大于0'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      packageMethodItems: [],
    }
  },
  computed: {
    categoryParams() {
      return { parentCode: this.formData.productLine, isEcom: 'N' }
    },
    packageMethodMaps() {
      if (!this.packageMethodItems?.length) return {}

      return Object.fromEntries(
        this.packageMethodItems.map((item) => [item.value, item])
      )
    },
    packageMethodName() {
      const packageMethod = this.formData?.packageMethod || []
      return packageMethod
        .map((item) => this.packageMethodMaps[item]?.label)
        .filter(Boolean)
        .join('、')
    },
  },
  activated() {
    this.getData()
  },
  watch: {
    sampleCode: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
    'formData.masterCategoryCode'(newVal, oldVal) {
      if (this.formData.metadata?.length && !oldVal && newVal) return
      if (!newVal) return (this.formData.metadata = [])
      this.$api
        .masSampleInputTemplateSelectApi({ sampleCategoryCode: newVal })
        .then((res) => {
          this.formData = { ...this.formData, metadata: res.body?.data || [] }
        })
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.sampleCode) return
      this.getSampleData(this.sampleCode).then((res) => {
        this.formData = res.body || {}
        this.formData = {
          ...this.formData,
          metadata: this.formData.listTemolate,
        }
        this.$emit('update:productLine', this.formData.productLine || '')
        this.$emit(
          'update:masterCategoryCode',
          this.formData.masterCategoryCode || ''
        )
      })
    },
    async getSampleData(sampleCode) {
      if (this.proofingCode) {
        return await this.$api.proofingSampleInfoDetailApi({ sampleCode })
      }
      return await this.$api.sampleInfoDetailApi({ sampleCode })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return false
      }

      const dynamicFormResult = await validate.formValidate([
        this.$refs.dynamicForm,
      ])

      if (!dynamicFormResult) return false

      this.loadingOpen()
      this.formData.categoryCodeName = this.formData.productLine

      this.saveSample()
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.sampleCode) {
            const { body } = res
            if (this.proofingCode) {
              this.$emit('reload', body)
              return
            }
            this.$router.replace({
              name: 'sample-sampleInformation-detail',
              params: {
                sampleCode: body,
                pageType: 'edit',
              },
            })
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          return false
        })
    },
    async saveSample() {
      if (this.proofingCode) {
        return await this.$api.proofingSampleInfoSaveApi({
          ...this.formData,
          proofingCode: this.proofingCode,
          // packageMethodName: this.packageMethodName,
        })
      }
      return await this.$api.sampleInfoSaveApi({
        ...this.formData,
        packageMethodName: this.packageMethodName,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
